import { EventStatus, EventType, type MatrixEvent, type Room } from 'matrix-js-sdk'

export const CHRONOLOGICAL_PENDING_ERROR =
  'Cannot call getPendingEvents with pendingEventOrdering == chronological'

/** Read unsent messages in either SDK ordering without changing timeline behavior. */
export function getRetryableRoomMessages(room: Room): MatrixEvent[] {
  let events: MatrixEvent[]
  try {
    events = room.getPendingEvents()
  } catch (error) {
    // The default chronological mode keeps local echoes in the live timeline;
    // getPendingEvents() is only supported with pendingEventOrdering=detached.
    if (!(error instanceof Error)
      || error.message !== CHRONOLOGICAL_PENDING_ERROR) {
      throw error
    }
    events = room.getLiveTimeline().getEvents()
  }

  return events.filter(event => event.status === EventStatus.NOT_SENT
    && event.getType() === EventType.RoomMessage)
}
